import { DeviceLinkModel } from 'src/Libs/installations/models'

export const getActiveDeviceLinksOnly = (unfilteredDeviceLinks?: DeviceLinkModel[]): DeviceLinkModel[] | undefined => {
  return unfilteredDeviceLinks?.filter(device => device.stopAt === null)
}
